/**
 * Angular core components declaration
 **/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

/**
 * Admin Modules declaration
 **/
import { LanguageModule } from '../common/services/languages/language.module';


import { RouterModule } from '@angular/router';

/**
 * Admin Services declaration
 **/
import { TranslationService } from '../common/services/languages/translation.service';

/**
 * Admin Modules declaration
 **/
import { VcmComponent } from './vcm/vcm.component';
import { VcmInterceptorService } from './services/header-interceptor/vcm-header-interceptor.service';
import { VcmMainComponent } from './vcm-main/vcm-main.component';
import { OrchestrationService } from './services/orchestration-service/orchestration.service';
import { VcmRoutingModule } from './vcm-routing.module';
import { CommonModule } from '@angular/common';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    RouterModule,
    VcmRoutingModule,
    CommonModule, VcmComponent,
    VcmMainComponent], providers: [
        TranslationService,
        { provide: HTTP_INTERCEPTORS, useClass: VcmInterceptorService, multi: true },
        OrchestrationService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class VcmModule {
  constructor() {
  }
}
